import React from 'react';
import { useTheme } from 'styled-components';

const AlignIcon = ({ size = 16, color, ...props }) => {
  const theme = useTheme();
  const stroke = color || (theme?.dark ? '#F3E6F4' : '#4A154B');
  return (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.33301 3H14.333"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33301 6.33325H8.64634"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33301 9.66675H14.333"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33301 13H8.64634"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    </svg>
  );
};

export default AlignIcon;
